module.exports = __webpack_public_path__ + "img/Latvia.1879756c.png";